module.exports = __webpack_public_path__ + "static/img/new_daily_my2019_bannerinternal.143431f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/videodaily/new_daily_my2019_bannerinternal.jpg
// module id = U6MX
// module chunks = 1